import { DynamicStandaloneLink, DynamicStandaloneLinkProps } from '@/components/Link';
import { componentTheme } from '@/styles/SavedArticles';
import { StandaloneComponent } from '@/types/component';
import mergeProps from 'lib/utils/mergeProps';

export type SavedArticlesArticleLinkProps = DynamicStandaloneLinkProps;

export const SavedArticlesArticleLinkComponent: StandaloneComponent<SavedArticlesArticleLinkProps> = (props) => {
  return (
    <DynamicStandaloneLink
      {...mergeProps(
        {
          options: {
            theme: componentTheme('link'),
          },
        },
        props
      )}
    />
  );
};
